import { Card, CardHeader, Box, Grid, CardActionArea } from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import Accordion, { Schedule } from '../accordion/AccordionScheduleDay'
import Typography from '../base/Typography'
import Tags from '../tags/Tags'

interface CleanerContract {
  id: string
  startDate: string
  salary: number
  periodSalary: string
  cleanerType: string
  endDate?: string
  schedule?: Schedule[]
}

export type CardCleanerContractProps = {
  contracts: CleanerContract
  onClick(id: string): void
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 265,
      padding: theme.spacing(2),
      position: 'relative',
      background: theme.palette.common.white,
      boxShadow: theme.shadows[1],
      borderRadius: theme.spacing(0.5)
    },
    verticalLine: {
      borderLeft: 'solid 3px #2D9CDB',
      paddingLeft: theme.spacing(1),
      borderRadius: '0px'
    },
    cardHeader: {
      padding: 0,
      marginBottom: theme.spacing(1)
    },
    textColor: {
      color: theme.palette.grey[800]
    },
    nameLabel: {
      marginRight: theme.spacing(1.4)
    },
    endDateLabel: {
      marginRight: theme.spacing(1.9)
    },
    salaryLabel: {
      marginRight: theme.spacing(4.1)
    }
  })
)

const CardCleanerContract: React.FC<CardCleanerContractProps> = (props) => {
  const { contracts, onClick } = props
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)
  const accordionOpen = (event: { stopPropagation: () => void }): void => {
    setExpanded(!expanded)
    event.stopPropagation()
  }
  return (
    <CardActionArea
      onClick={(): void => onClick(contracts.id)}
      className={classes.root}
    >
      <Card className={expanded ? classes.verticalLine : ''} elevation={0}>
        <CardHeader
          className={classes.cardHeader}
          title={
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                children={`Contract ${contracts.id}`}
                variant="subtitle2"
              />
              <Tags
                customVariant="officeCleaning"
                sizes="xs"
                label={contracts.cleanerType}
              />
            </Box>
          }
        />
        <Grid
          container
          direction="column"
          justify="flex-start"
          alignItems="flex-start"
        >
          <Box display="flex" marginBottom={0.5}>
            <Typography
              className={`${classes.textColor} ${classes.nameLabel}`}
              variant="overline"
              children="Start Date:"
            />
            <Typography
              bodyVariants="xsMedium"
              children={contracts.startDate}
            />
          </Box>
          {contracts.endDate && (
            <Box display="flex" marginBottom={0.5}>
              <Typography
                className={`${classes.textColor} ${classes.endDateLabel}`}
                variant="overline"
                children="End Date:"
              />
              <Typography
                bodyVariants="xsMedium"
                children={contracts.endDate}
              />
            </Box>
          )}
          <Box display="flex" marginBottom={0.5}>
            <Typography
              className={`${classes.textColor} ${classes.salaryLabel}`}
              variant="overline"
              children="Salary:"
            />
            <Typography
              bodyVariants="xsMedium"
              children={`$${contracts.salary} / ${contracts.periodSalary}`}
            />
          </Box>
          {!!contracts.schedule?.length && (
            <Box onClick={accordionOpen}>
              <Accordion
                children=""
                marginTop={1}
                marginBottom={0.5}
                sizes="small"
                labelVariant="overline"
                schedule={contracts.schedule}
              />
            </Box>
          )}
        </Grid>
      </Card>
    </CardActionArea>
  )
}

export default CardCleanerContract
